import React, { Component, PropTypes } from 'react'
import moment from 'moment'

import { sendPatchRequest } from '../utils'

import {
    Label,
    RadioInput,
    Select,
    TextInput,
} from '../ui'

export default class PersonalForm extends Component {
    static propTypes = {
        data: PropTypes.object,
        errors: PropTypes.object.isRequired,
        options: PropTypes.object.isRequired,
        updateValue: PropTypes.func.isRequired,
        updateValueAndSendPatchRequest: PropTypes.func.isRequired,
    }

    state = {}

    componentWillMount() {
        if (this.props.data && this.props.data.dob) {
            this._setDOB(this.props.data.dob)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.data && ! (
            this.props.data &&
            nextProps.data.dob === this.props.data.dob
        )) {
            this._setDOB(nextProps.data.dob)
        }
    }

    _setDOB(dob) {
        if (moment(dob).isValid()) {
            this.setState({
                dob_year: moment(dob).format('YYYY'),
                dob_month: moment(dob).format('MM'),
                dob_day: moment(dob).format('DD'),
            })
        }
    }

    _onSelectCountry = (data) => {
        this.props.data.country_code = this.props.options.getCountryCode(data.country)

        if (this.props.data.country_code === 'US') {
            this.props.options.loadRegions(data.country)
        }

        this.props.updateValueAndSendPatchRequest({
            country: data.country,
            region: null,
            city: null,
        })

        this.props.options.cities = []
    }

    _onSelectRegion = (data) => {
        this.props.updateValueAndSendPatchRequest({
            region: data.region,
            city: null,
        })

        this.props.options.cities = []
    }

    _onSearchCity = (value) => {
        this.props.options.loadCities(this.props.data.country, this.props.data.region, value)
    }

    _updateDOB = (data) => {
        let { dob_day, dob_month, dob_year } = this.state

        if ('dob_day' in data) {
            dob_day = data.dob_day
        }
        if ('dob_month' in data) {
            dob_month = data.dob_month
        }
        if ('dob_year' in data) {
            dob_year = data.dob_year
        }

        this.setState({
            dob_day,
            dob_month,
            dob_year,
        })

        const dob = moment({
            year: parseInt(dob_year, 10),
            month: parseInt(dob_month, 10) - 1,
            day: parseInt(dob_day, 10),
        })

        if (dob.isValid()) {
            this.props.updateValueAndSendPatchRequest({ dob: dob.format('YYYY-MM-DD') })
        } else {
            if (dob_day && dob_month && dob_year) {
                // eslint-disable-next-line no-alert
                alert('Please ensure you have entered a valid date of birth.')
            }
        }
    }

    _dayOptions() {
        /* eslint-disable no-magic-numbers */
        const options = []

        let i = 1

        while (i <= 31) {
            options.push({
                'value': (i < 10) ? `0${ i }` : `${ i }`,
                'label': (i < 10) ? `0${ i }` : `${ i }`,
            })

            i++
        }

        return options
        /* eslint-enable no-magic-numbers */
    }

    _monthOptions() {
        return [
            {
                value: '01',
                label: 'January',
            },
            {
                value: '02',
                label: 'February',
            },
            {
                value: '03',
                label: 'March',
            },
            {
                value: '04',
                label: 'April',
            },
            {
                value: '05',
                label: 'May',
            },
            {
                value: '06',
                label: 'June',
            },
            {
                value: '07',
                label: 'July',
            },
            {
                value: '08',
                label: 'August',
            },
            {
                value: '09',
                label: 'September',
            },
            {
                value: '10',
                label: 'October',
            },
            {
                value: '11',
                label: 'November',
            },
            {
                value: '12',
                label: 'December',
            },
        ]
    }

    _sexOptions() {
        return [
            {
                value: 'MALE',
                label: 'Male',
            },
            {
                value: 'FEMALE',
                label: 'Female',
            },
        ]
    }

    _yearOptions() {
        const currentYear = parseInt(moment().format('YYYY'))

        const options = []

        let i = 0

        // eslint-disable-next-line no-magic-numbers
        while (i <= 100) {
            const year = currentYear - i

            options.push({
                'value': `${ year }`,
                'label': `${ year }`,
            })

            i++
        }

        return options
    }

    render() {
        const errors = this.props.errors

        if (! this.props.data) {
            return null
        }

        let regionField = null

        if (this.props.data.country_code === 'US') {
            regionField = (
                <div className="grid grid--break-mobile">
                    <div className="grid__span-5">
                        <Select
                            error={ errors.region }
                            name="region"
                            options={ this.props.options.regions || [] }
                            placeholder="Select your state"
                            updateValue={ this._onSelectRegion }
                            value={ this.props.data.region }
                        />
                    </div>
                </div>
            )
        }

        let cityDefaultOptions = []

        if (this.props.data.city) {
            cityDefaultOptions = [
                {
                    value: this.props.data.city,
                    label: this.props.data.city_name,
                },
            ]
        }

        return (
            <div className="form">
                <Label>First & Last Name</Label>
                <div className="grid grid--break-mobile">
                    <div className="grid__span-3">
                        <TextInput
                            error={ errors.first_name }
                            handleBlur={ sendPatchRequest.bind(this, 'first_name') }
                            name="first_name"
                            placeholder="First name"
                            updateValue={ this.props.updateValue }
                            value={ this.props.data.first_name }
                        />
                    </div>
                    <div className="grid__span-4">
                        <TextInput
                            error={ errors.last_name }
                            handleBlur={ sendPatchRequest.bind(this, 'last_name') }
                            name="last_name"
                            placeholder="Last name"
                            updateValue={ this.props.updateValue }
                            value={ this.props.data.last_name }
                        />
                    </div>
                </div>
                <div className="grid grid--break-mobile">
                    <div className="grid__span-4">
                        <TextInput
                            error={ errors.email }
                            handleBlur={ sendPatchRequest.bind(this, 'email') }
                            label="E-mail"
                            name="email"
                            updateValue={ this.props.updateValue }
                            value={ this.props.data.email }
                        />
                    </div>
                    <div className="grid__span-8">
                        <Label>Cell Phone</Label>
                        <div className="grid grid--break-mobile">
                            <div className="grid__span-5">
                                <Select
                                    error={ errors.mobile_phone_dial_code }
                                    name="mobile_phone_dial_code"
                                    options={ this.props.options.countryDialCodeOptions() }
                                    placeholder="Select your country code"
                                    updateValue={ this.props.updateValueAndSendPatchRequest }
                                    value={ this.props.data.mobile_phone_dial_code }
                                />
                            </div>
                            <div className="grid__span-4">
                                <TextInput
                                    error={ errors.mobile_phone }
                                    handleBlur={ sendPatchRequest.bind(this, 'mobile_phone') }
                                    name="mobile_phone"
                                    placeholder="999.999.9999"
                                    updateValue={ this.props.updateValue }
                                    value={ this.props.data.mobile_phone }
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Label>Address</Label>
                <div className="grid grid--break-mobile">
                    <div className="grid__span-5">
                        <Select
                            error={ errors.country }
                            name="country"
                            options={ this.props.options.countryOptions || [] }
                            placeholder="Select your country"
                            updateValue={ this._onSelectCountry }
                            value={ this.props.data.country }
                        />
                    </div>
                    { regionField }
                </div>
                <div className="grid grid--break-mobile">
                    <div className="grid__span-5">
                        <Select
                            defaultOptions={ cityDefaultOptions }
                            error={ errors.city }
                            name="city"
                            noOptionPlaceholder="Type in city name"
                            options={ this.props.options.cities || [] }
                            placeholder="Select your city"
                            searchOptions={ this._onSearchCity }
                            updateValue={ this.props.updateValueAndSendPatchRequest }
                            value={ this.props.data.city }
                        />
                    </div>
                    <div className="grid__span-5">
                        <TextInput
                            error={ errors.zipcode }
                            handleBlur={ sendPatchRequest.bind(this, 'zipcode') }
                            name="zipcode"
                            placeholder="Zipcode"
                            updateValue={ this.props.updateValue }
                            value={ this.props.data.zipcode }
                        />
                    </div>
                </div>
                <div className="grid grid--break-mobile">
                    <div className="grid__span-5">
                        <TextInput
                            error={ errors.street }
                            handleBlur={ sendPatchRequest.bind(this, 'street') }
                            name="street"
                            placeholder="Street address"
                            updateValue={ this.props.updateValue }
                            value={ this.props.data.street }
                        />
                    </div>
                    <div className="grid__span-5">
                        <TextInput
                            error={ errors.apt_suite }
                            handleBlur={ sendPatchRequest.bind(this, 'apt_suite') }
                            name="apt_suite"
                            placeholder="Apt/Suite"
                            updateValue={ this.props.updateValue }
                            value={ this.props.data.apt_suite }
                        />
                    </div>
                </div>
                <Label>Date of Birth</Label>
                <div className="grid grid--break-mobile">
                    <div className="grid__span-3">
                        <Select
                            error={ errors.dob }
                            name="dob_month"
                            options={ this._monthOptions() }
                            placeholder="Month"
                            updateValue={ this._updateDOB }
                            value={ this.state.dob_month }
                        />
                    </div>
                    <div className="grid__span-2">
                        <Select
                            error={ errors.dob }
                            name="dob_day"
                            options={ this._dayOptions() }
                            placeholder="Day"
                            updateValue={ this._updateDOB }
                            value={ this.state.dob_day }
                        />
                    </div>
                    <div className="grid__span-2">
                        <Select
                            error={ errors.dob }
                            name="dob_year"
                            options={ this._yearOptions() }
                            placeholder="Year"
                            updateValue={ this._updateDOB }
                            value={ this.state.dob_year }
                        />
                    </div>
                </div>
                <div className="grid grid--break-mobile">
                    <div className="grid__span-6">
                        <RadioInput
                            error={ errors.sex }
                            label="Sex"
                            name="sex"
                            options={ this._sexOptions() }
                            updateValue={ this.props.updateValueAndSendPatchRequest }
                            value={ this.props.data.sex }
                        />
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/personal/personal_form.js